import React, { useCallback, memo } from "react";
import styled, { DefaultTheme } from "styled-components/native";
import { SpaceType } from "../Spacer/types";
import TabSectionButton from "../TabSectionButton";
import { ProductCategory } from "@utils/constants";
import { useUserAnalytics } from "../../../hooks/useAnalytics";
import {
  AIEventNames,
  AIEventTypes,
} from "@scenes/authentication/utils/Types/types";

type FiltersTabSectionProps = {
  filtersLayout: any;
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
  fromSplitScreen: boolean;
  productType: ProductCategory;
  sectionName: string;
};

const FiltersTabSection = ({
  filtersLayout,
  selectedTab,
  setSelectedTab,
  fromSplitScreen,
  productType,
}: FiltersTabSectionProps) => {
  if (!filtersLayout?.length) return null;
  const { trackEvent } = useUserAnalytics() || {};

  const onSelectTab = useCallback(
    (tabId: string) => {
      setSelectedTab(tabId);
      trackEvent?.(AIEventNames.AI_CHAT_WIDGET, {
        action:
          tabId === "vdb_ai_search"
            ? AIEventTypes.VDB_AI_SEARCH_CLICKED
            : AIEventTypes.CLASSIC_SEARCH_CLICKED,
      });
    },
    [setSelectedTab]
  );

  return (
    <Container fromSplitScreen={fromSplitScreen}>
      {filtersLayout?.map((tab: any) => (
        <TabSectionButton
          key={tab.name}
          name={tab?.name}
          title={tab?.label}
          isSelected={selectedTab === tab?.name}
          onPress={() => onSelectTab(tab?.name)}
          icon={tab?.icon}
          productType={productType}
        />
      ))}
    </Container>
  );
};

export default memo(FiltersTabSection);

const Container = styled.View<{
  fromSplitScreen: boolean;
}>`
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-01"]};
  flex-direction: row;
  padding: ${SpaceType.Extra}px ${SpaceType.Double}px;
  gap: ${SpaceType.Basic}px;
  justify-content: center;
`;
